<template>
    <div class="huifei">
        <div class="top">
            <i class="el-icon-edit"></i>
            <div>账号管理>续费流水</div>
        </div>
        <div class="body">
            <div style="display: flex;margin-top: 30px;margin-bottom: 20px;">
                <div style="width: 5px;height: 40px;background-color: #0000FF;"></div>
                <span style="line-height: 40px;margin-left: 10px;font-weight: 700; color: #666;">会员会费<span style="margin-left: 10px; font-size: 10px;color: #999;">第二天生效</span></span>
            </div>
            <div  class="tabel_box">
                <div class="border_botton">
                    <span class="first_width" style="height: 50px;">会员等级</span>
                    <span class="border_left line_height100" v-for="item in dataList">
                        <span class="">{{item.name}}</span>
                    </span>
                </div>
                <div class="border_botton">
                    <span class="first_width">会费</span>
                    <span class="border_left" v-for="item in dataList">
                        <div style="margin-top: 40px;margin-bottom: 8px;">{{item.originPrice}}</div>
                        <span v-if="item.updateOriginPrice" style="color: #999; font-size: 12px;">明日00:00 会费变更为{{item.updateOriginPrice}}</span>
                    </span>
                </div>
                <div class="border_botton" >
                    <span class="first_width">优惠价</span>
                    <span class="border_left"  v-for="item in dataList">
                        <div style="margin-top: 40px;margin-bottom: 8px;">{{item.preferentialPrice?item.preferentialPrice:"————"}}</div>
                        <span v-if="item.open==0&&item.preferentialPrice" style="color: #999; font-size: 12px;">明日00:00 优惠价取消</span>
                        <span v-if="item.updatePreferentialPrice" style="color: #999; font-size: 12px;">{{`明日00:00 优惠价变更为${item.updatePreferentialPrice}`}}</span>
                    </span>
                </div>
                <div class="" style="height: 100px;display: flex;">
                    <span class="first_width">操作</span>
                    <span class="border_left line_height100" v-for="item in dataList">
                        <span @click="changeVip(item)" style="cursor: pointer; margin-right: 20px;color: #0000FF;">变更会员</span>
                        <span @click="discountPrice(item)" style="cursor: pointer; color: #0000FF;">设置优惠价</span>
                    </span>
                </div>
            </div>
        </div>
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item v-if="dialogTitle=='变更会员'" label="会费" prop="member">
                    <el-input v-model="ruleForm.member"></el-input>
                </el-form-item>
                <el-form-item v-if="dialogTitle=='设置优惠价'" label="是否优惠">
                    <el-switch
                        v-model="ruleForm.value"     
                        active-color="#2D8CF0"
                        inactive-color="#CCCCCC"
                        >
                    </el-switch>
                </el-form-item>
                <el-form-item v-if="dialogTitle=='设置优惠价'" label="优惠价" prop="discount">
                    <el-input :disabled="!ruleForm.value" v-model="ruleForm.discount"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="editBtn('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
      data(){
        var checkAge = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('会员会费不能为空'));
            }else{
                let reg=/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                if(!reg.test(value)){
                    callback(new Error('会员会费只能为数字且最多两位小数'));
                }else{
                    if (value <=0) {
                    callback(new Error('会员会费必须大于0'));
                    }else{
                        callback()
                    } 
                }
            }
        };
        var checkDiscount = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('优惠价不能为空'));
            }else{
                let reg=/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                if(!reg.test(value)){
                    callback(new Error('优惠价只能为数字且最多两位小数'));
                }else{
                    if (value <=0) {
                    callback(new Error('优惠价必须大于0'));
                    }else{
                        callback()
                    } 
                }
            }
        };
        return{
            dataList:[],
            dialogVisible:false,
            dialogTitle:"",
            ruleForm:{
                member:null,
                value:false,
                discount:null
            },
            typeId:null,
            rules: {
                member: [
                    // { required: true, message: '请输入新的会费', trigger: 'blur' },
                    { validator: checkAge, trigger: 'blur' }
                ],
                discount:[
                    { validator: checkDiscount, trigger: 'blur' }
                ],
            }
        }
      },
      created(){

      },
      mounted(){
        this.getMemberType();
        // console.log(typeof(3.1542));
      },
      methods:{
        //查询会员会费
        getMemberType(){
            this.$http.get(`memberType`).then((res)=>{
                if(res.code==200){
                    this.dataList=res.data;
                    console.log(this.dataList);
                }else{
                    this.$message.error("获取会员会费失败")
                }
            })
        },  
        // 变更会员
        changeVip(type){
            console.log(type);
            this.typeId=type.id;
            this.dialogVisible=true;
            this.dialogTitle="变更会员";
            this.ruleForm.member=type.originPrice;
        },
        //设置优惠价
        discountPrice(type){
            console.log(type);
            this.dialogVisible=true;
            this.typeId=type.id;
            this.dialogTitle="设置优惠价";
            this.ruleForm.value=(type.open==1);
            if(type.open==1){
                this.ruleForm.discount=type.updatePreferentialPrice?type.updatePreferentialPrice:type.preferentialPrice;
            }else{
                this.ruleForm.discount=null
            }
        },
        //修改变更会员和设置优惠价确定按钮
        editBtn(formName){
            console.log(this.ruleForm.value);
            // if(this.ruleForm.value==0){
            //     this.ruleForm.discount=null;
            // }
            this.$refs[formName].validate((valid) => {
                if(valid){
                    let price=null;
                    //判断会员类型：2是月费；3是终生
                    if(this.dialogTitle=="变更会员"){
                        price=Number(this.ruleForm.member);
                    }else{
                        price=Number(this.ruleForm.discount);
                    }
                    console.log(this.typeId,price,this.dialogTitle=="变更会员"?1:2,this.ruleForm.value);
                    // if(this.ruleForm.value==0){
                    //     this.$http.put(`/memberType?id=${this.typeId}&&priceType=${this.dialogTitle=="变更会员"?1:2}&&open=${this.ruleForm.value?1:0}`).then((res)=>{
                    //         if(res.code==200){
                    //             this.$message.success("修改成功")
                    //         }else{
                    //             this.$message.error("修改失败",res.message);
                    //         }
                    //     })
                    // }else{
                        this.$http.put(`/memberType?id=${this.typeId}&&price=${price}&&priceType=${this.dialogTitle=="变更会员"?1:2}&&open=${this.ruleForm.value?1:0}`).then((res)=>{
                            if(res.code==200){
                                this.$message.success("修改成功");
                                this.getMemberType();
                            }else{
                                this.$message.error("修改失败",res.message);
                            }
                        })
                    // }
                    this.dialogVisible = false;
                }else{
                    console.log('error submit!!');
                    return false;
                }
            });
            
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
            .then(_ => {
                done();
            })
            .catch(_ => {});
        }
      }
    }
</script>

<style lang="less" scoped>
.huifei{
    width: 100%;
    height: 100%;
    box-sizing: border-box ;
    background: #fff;
    min-height: 829px;
    padding: 10px 20px;
    .top{
        width: 100%;
        height: 20px;
        display: flex;
        align-items: center;
        box-sizing: border-box
    }
    .body{
        // display: flex;
        .tabel_box{
            width: 100%;
            border: 2px solid #EAEAEA;
            text-align: center;
            margin: auto 0;
            .border_botton{
                height: 100px;
                display: flex;
                border-bottom: 2px solid #EAEAEA;
            }
            .border_left{
                height: 100px;
                width: 40%;
                border-left: 2px solid #EAEAEA;
                color: #666666;
            }
            .first_width{
                width: 20%;
                font-weight: 600;
                color: #666666;
                line-height: 100px;
            }
            .line_height100{
                line-height: 100px;
            }
        }
        .tabel_box div{
            // background: #000;
            // height: 100%;
        }
        // .tabel_box :nth-child(1),.tabel_box :nth-child(3),.tabel_box :nth-child(2){
        //     width: 100%;
        //     border: 1px solid #000;
        // }
    }
}
</style>